export const FETCH_FOLDER = "FETCH_FOLDER_TAG";
export const FETCH_MSS_FOLDER = "FETCH_MSS_FOLDER_TAG";
export const FETCH_REC_DETAILS = "FETCH_REC_DETAILS_TAG";
export const USER_PROFILES = "USER_PROFILES_API"
export const FOLDER_COUNT = "FOLDER_COUNT_API"
